/* Product page hover zoom: a lens on the main image and an enlarged view over the product info column (desktop mouse only). */
(function () {
  if (window.mlZoomReady) return;
  window.mlZoomReady = true;

  var ZOOM = 2.6;
  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  var pane, lens, activeSrc;

  function ensure() {
    if (pane) return;
    pane = document.createElement('div');
    pane.className = 'ml-zoom-pane';
    lens = document.createElement('div');
    lens.className = 'ml-zoom-lens';
    document.body.appendChild(pane);
    document.body.appendChild(lens);
  }

  function hide() {
    if (!pane) return;
    pane.classList.remove('is-on');
    lens.classList.remove('is-on');
  }

  function largest(img) {
    var best = img.currentSrc || img.src;
    var bw = 0;
    (img.getAttribute('srcset') || '').split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/);
      var w = parseInt(bits[1], 10);
      if (bits[0] && w > bw) { bw = w; best = bits[0]; }
    });
    return best;
  }

  // Rendered box of an object-fit: contain image.
  function drawnRect(img) {
    var r = img.getBoundingClientRect();
    var ratio = img.naturalWidth / img.naturalHeight;
    if (!ratio) return r;
    var w = r.width, h = r.height;
    if (w / h > ratio) w = h * ratio; else h = w / ratio;
    return { left: r.left + (r.width - w) / 2, top: r.top + (r.height - h) / 2, width: w, height: h };
  }

  document.addEventListener('mousemove', function (e) {
    if (!mq.matches) return hide();
    var item = e.target.closest && e.target.closest('[id^="GalleryViewer"] .product__media-item.is-active');
    var img = item && item.querySelector('img');
    var info = item && item.closest('.product') && item.closest('.product').querySelector('.product__info-wrapper');
    if (!img || !info || !img.complete) return hide();

    var d = drawnRect(img);
    var x = e.clientX - d.left, y = e.clientY - d.top;
    if (x < 0 || y < 0 || x > d.width || y > d.height) return hide();

    ensure();
    var ir = info.getBoundingClientRect();
    var pw = Math.min(ir.width, 620);
    var ph = Math.min(d.height, window.innerHeight - Math.max(d.top, 0) - 16);
    var src = largest(img);
    if (src !== activeSrc) { pane.style.backgroundImage = 'url("' + src + '")'; activeSrc = src; }

    pane.style.left = ir.left + 'px';
    pane.style.top = Math.max(d.top, 8) + 'px';
    pane.style.width = pw + 'px';
    pane.style.height = ph + 'px';
    pane.style.backgroundSize = d.width * ZOOM + 'px ' + d.height * ZOOM + 'px';

    var lw = Math.min(pw / ZOOM, d.width), lh = Math.min(ph / ZOOM, d.height);
    var lx = Math.max(0, Math.min(x - lw / 2, d.width - lw));
    var ly = Math.max(0, Math.min(y - lh / 2, d.height - lh));
    lens.style.left = d.left + lx + 'px';
    lens.style.top = d.top + ly + 'px';
    lens.style.width = lw + 'px';
    lens.style.height = lh + 'px';
    pane.style.backgroundPosition = -lx * ZOOM + 'px ' + -ly * ZOOM + 'px';

    pane.classList.add('is-on');
    lens.classList.add('is-on');
  }, { passive: true });

  document.addEventListener('mouseout', function (e) {
    var item = e.target.closest && e.target.closest('[id^="GalleryViewer"] .product__media-item');
    if (item && !item.contains(e.relatedTarget)) hide();
  });
  document.addEventListener('pointerdown', function (e) {
    if (!(e.target.closest && e.target.closest('[id^="GalleryViewer"]'))) hide();
  });
  document.addEventListener('scroll', hide, { passive: true });
  document.addEventListener('mouseleave', hide);
})();
